import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_EQUIPMENT } from "../../../../../common/constants/modules"

import { equipmentQueryKeys } from "./queryKeys"
import { useEquipmentQuery } from "./useEquipmentQuery"


export function useEquipmentsCategoriesStats(parameters = {}, config = {}) {
    const url = "equipments/stats/equipment_types/"

    const queryParameters = useExtendWithSubnetworks(parameters, API_MODULE_EQUIPMENT)
    const queryKey = equipmentQueryKeys["stats_categories"](queryParameters)

    return useEquipmentQuery(
        url,
        queryKey,
        queryParameters,
        {
            ...config,
        },
    )
}